import { gsap } from "../../node_modules/gsap/index.js";
import { ScrollTrigger } from "../../node_modules/gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

let allNodes = document.querySelectorAll("#step-up-and-own-it ol li:not(#Intro)");
let allSections = [].slice.call(allNodes);
let sectionCount = allSections.length;

while(sectionCount-- > 5) {
  let ranIndex = Math.floor(Math.random() * (sectionCount+1));
  allSections[ranIndex].remove();
  allSections.splice(ranIndex,1);
}

let sections = gsap.utils.toArray("#step-up-and-own-it ol li");
let sliderWidth = document.querySelector("#step-up-and-own-it ol").offsetWidth;
let slideWidth = document.querySelector("#step-up-and-own-it ol li#Intro").clientWidth;
let beliefWidth = document.querySelector("#slider-belief").clientWidth;

gsap.to(sections, {
  xPercent: -100 * (sections.length - 1),
  //xPercent: -100 * (sections.length - 2) - 55,
  ease: "none",
  scrollTrigger: {
    trigger: "#step-up-and-own-it-wrapper",
    pin: true,
    start: "top +=0px",
    scrub: 1,
    snap: {
      //snapTo: [0, .12, .34, .56, .78, 1],
      snapTo: 1 / (sections.length - 1),
      duration: {min: 0.05, max: 0.1},
      delay: 0
    },
    // Base vertical scrolling on how wide the container is so it feels more natural.
    end: () => "+=" + (sliderWidth / 5)
  }
});

gsap.to("#slider-belief", {
  x: slideWidth*5.2 - beliefWidth,
  ease: "none",
  scrollTrigger: {
    trigger: "#step-up-and-own-it-wrapper",
    start: "top +=10px",
    scrub: 1,
    // Base vertical scrolling on how wide the container is so it feels more natural.
    end: () => "+=" + (sliderWidth / 5)
  }
});

document.addEventListener('click', function (event) {
  if (!event.target.matches(".scroll button, .scroll .underline")) return;
  event.preventDefault();
  scroll({
    top: window.scrollY + document.querySelector("#step-up-and-own-it ol").getBoundingClientRect().top + document.querySelector("#step-up-and-own-it li#Intro .flex").clientWidth/6-50,
    behavior: "smooth"
  });
}, false);
